import { ExamData } from "../../../services/Exams-Moldes/types";
import { Exam } from "../../../services/TurnServices/Turns.type";
import { PracticesLayout } from "./PracticesLayout";

export type ExamDetailsProps = {
  exam: Exam | ExamData;
};

export const ExamDetails: React.FC<ExamDetailsProps> = ({ exam }) => (
  <>
    <hr />
    {exam.practices.length > 0 && (
      <PracticesLayout
        practices={exam.practices}
        listContainerStyles="max-w-lg"
        listItemsStyles="mb-6 mr-2"
        keyPrefix="e.p-"
      />
    )}
    <hr />
  </>
);
